import Image from "next/image";
import Link from "next/link";
import { useLocale, useTranslations } from "next-intl";
import { useTheme } from "next-themes";
import { Button } from "@repo/ui/components/ui/button";
import { useEffect, useMemo, useState } from "react";

export default function HowWorks() {
  const t = useTranslations("Home.how_works");
  const locale = useLocale().split("-")[0] || "it";
  const howWorksKeys = ["card1", "card2", "card3"] as const;
  const [mounted, setMounted] = useState(false);
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    setMounted(true);
  }, []);

  const colorScheme = useMemo(() => {
    if (!mounted) return undefined;
    return resolvedTheme; // 'light' | 'dark'
  }, [mounted, resolvedTheme]);

  if (!mounted) return null;

  return (
    <section
      id="how-works"
      className="scroll-mt-[200px] max-md:scroll-mt-[100px] mt-[50px] max-md:mt-[20px] max-md:scroll-mt-[60px]"
    >
      <h2 className="text-center mb-[40px] max-md:mb-[20px] leading-none max-md:text-[30px]">
        {t("title")}
      </h2>
      <div className="grid grid-cols-3 gap-8 max-md:grid-cols-1">
        {howWorksKeys.map((key) => (
          <div key={key} className="flex flex-col gap-[20px] items-center">
            <h3 className="md:h-[40px] text-[24px] font-normal">
              {t(`${key}.title`)}
            </h3>
            <div className="relative w-full aspect-[3/2]">
              <Image
                src={`/how-works/${key}_${colorScheme}_${locale}.webp`}
                alt={t(`${key}.title`)}
                fill
                sizes="100vw"
                quality={100}
                style={{ objectFit: "cover", objectPosition: "center" }}
              />
            </div>
            <p className="text-center flex-1">
              {t.rich(`${key}.content`, {
                br: () => <br />,
              })}
            </p>
            <Link href={t(`${key}.link`)} className="self-end">
              <Button className="px-0 text-[16px]" variant="link">
                {t("show_more")}
              </Button>
            </Link>
          </div>
        ))}
      </div>
      <div className="w-full flex justify-center">
        <Link href="/search">
          <Button className="mt-[40px] max-md:mb-[40px]" variant="default">
            {t("what_searching")}
          </Button>
        </Link>
      </div>
    </section>
  );
}
